import { jsx } from "react/jsx-runtime";
import cx from "classnames";
import { TextWrapper } from "@ingka/text";
var ListTextStyle = /* @__PURE__ */ ((ListTextStyle2) => {
  ListTextStyle2["small"] = "S";
  ListTextStyle2["medium"] = "M";
  ListTextStyle2["large"] = "L";
  return ListTextStyle2;
})(ListTextStyle || {});
const List = (props) => {
  const {
    prefix = "",
    ordered = false,
    size = "medium",
    children,
    className,
    ...other
  } = props;
  const baseClass = `${prefix}list`;
  const classes = cx(
    baseClass,
    className,
    ordered ? `${baseClass}--ordered` : `${baseClass}--unordered`,
    size && `${baseClass}--${size}`
  );
  return !ordered ? /* @__PURE__ */ jsx("ul", { className: classes, ...other, children: /* @__PURE__ */ jsx(TextWrapper, { textStyle: `Body.${[ListTextStyle[size]]}`, prefix, children }) }) : /* @__PURE__ */ jsx("ol", { className: classes, ...other, children: /* @__PURE__ */ jsx(TextWrapper, { prefix, children }) });
};
var List_default = List;
export {
  List_default as default
};
